import { useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { captureReferralCode } from '@/lib/referral';

export function ReferralCapture() {
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    const ref = searchParams.get('ref');
    if (ref) {
      captureReferralCode(ref);
      // Strip the ref param from the URL without a navigation
      const next = new URLSearchParams(searchParams);
      next.delete('ref');
      setSearchParams(next, { replace: true });
    }
  }, [searchParams, setSearchParams]);

  return null;
}
